/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerCreateMutationResponse } from "../../models/incidentAgentController/IncidentScenarioControllerCreate";

function getIncidentScenarioControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/incident-agent/scenarios` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/scenarios}
 */
export async function incidentScenarioControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentScenarioControllerCreateMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentScenarioControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}